import React from 'react'
import { Breadcrumb, Meta } from '../../../components'
import { renderMeta, useViewport, viewportBreakpoint } from '../../../utils'

const routes = [
  {
    name: 'Home',
    route: '/',
  },
  {
    name: 'Organization',
    route: '/organization'
  }
]

const Card = ({data = {}}) => {
  const {
    name,
    image,
    type,
    since,
    approach,
    location,
    // issues
  } = data

  const { width } = useViewport()
  const isMobile = width < viewportBreakpoint.tablet

  const size = isMobile ? '68px' : '120px'
  const backgroundSize = '60%'

  return (
    <div>
      <div
        className="rounded flex text-white -mx-2 lg:-mx-4 mb-8 lg:mb-0"
        style={{boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.05)'}}
      >
        {/* Image */}
        <div className="w-1/4 lg:w-auto px-2 lg:px-4">
          <div
            className="lg:w-full h-full bg-center bg-auto bg-no-repeat rounded rounded-full"
            style={{
              width: size, height: size,
              backgroundColor: '#f9f9f9',
              backgroundImage: `url('/images/logos/${image}')`,
              backgroundBlendMode: 'multiply',
              backgroundSize: backgroundSize
            }}
          />
        </div>

        <div className="w-3/4 lg:w-auto px-2 lg:px-4">
          {/* Content */}
          <div className="w-full">
            <div className="mb-2 lg:mb-5">
              <Breadcrumb routes={routes}/>
            </div>
            <h3 className="text-xl md:text-5xl mb-2 lg:mb-5 leading-tight font-accent uppercase">
              {name}
            </h3>
            <div className="w-full hidden lg:flex">
              <Meta
                className="mr-16"
                label="Location"
                value={location}
                lightOnMobile
              />
              <Meta
                className="mr-16"
                label="Established Since"
                value={since}
                lightOnMobile
              />
              <Meta
                className="mr-16"
                label="Type"
                value={renderMeta('type', type)}
                lightOnMobile
              />
              <Meta
                className="mr-16"
                label="Approach"
                value={renderMeta('approach', approach)}
                lightOnMobile
              />
              {/* <div className="w-3/5">
                <Meta
                  label="Issues"
                  value={issues}
                  lightOnMobile
                />
              </div> */}
            </div>
          </div>
        </div>
      </div>
      <div className="flex w-full lg:hidden -mx-2">
        <div className="px-2 mr-8">
          {/* <Meta
            label="Issues"
            value={issues}
            lightOnMobile
          /> */}
          <Meta
            className="mb-5"
            label="Location"
            value={location}
            lightOnMobile
          />
          <Meta
            label="Established Since"
            value={since}
            lightOnMobile
          />
        </div>
        <div className="px-2">
          <Meta
            className="mb-5"
            label="Type"
            value={renderMeta('type', type)}
            lightOnMobile
          />
          <Meta
            label="Approach"
            value={renderMeta('approach', approach)}
            lightOnMobile
          />
        </div>
      </div>
    </div>
  )
}

export { Card }
